import {GoogleMapPin} from 'components/icons/GoogleMapPin';
import React from 'react';
import {ResidenceType} from 'features/search/filters/enums';

import './_marker.scss';
import {SearchResult} from "features/search/types";

interface Props {
    lat: number;
    lng: number;
    children?: React.ReactNode;
    onClick?: () => void;
    residenceType: ResidenceType;
    stage: SearchResult;
    objects: SearchResult[];
    active: boolean;
}

export const Marker: React.FunctionComponent<Props> = ({children: _children, onClick, residenceType, stage, objects: _objects, active}) => {

    return (
        <GoogleMapPin onClick={onClick} stageStatus={stage.stageStatus} residenceType={residenceType} active={active} />
    );
};
